import { Button, DialogOverlay, DialogOverlayActions, DialogOverlayFooter, Paragraph } from '@fs/zion-ui'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import useNotifications from '../../../hooks/useNotifications'
import { deleteGroupMember } from '../../../services/groupsService'
import DeleteMembersList from './DeleteMembersList'
import { GroupContext } from '../GroupContextProvider'

export default function DeleteGroupMembersDialogOverlay({ members, refreshData, ...overlay }) {
  const { t } = useTranslation()
  const { fetchCurrentGroupData } = useContext(GroupContext)
  const { error } = useNotifications()
  const bodyText = getBodyText(members)

  const confirmBtnOnClick = async () => {
    overlay.close()
    try {
      await Promise.all(
        members.map((member) => {
          return deleteGroupMember(member.groupId, member.memberCisId)
        })
      )
      refreshData()
      fetchCurrentGroupData()
    } catch (err) {
      error(
        members.length > 1
          ? t('groups.errors.deletingMembers', {
              defaultValue: `Error deleting members: ${err.message || ''}`,
              message: err.message || '',
            })
          : t('groups.errors.deletingMember', {
              defaultValue: `Error deleting members: ${err.message || ''}`,
              message: err.message || '',
            }),
        err
      )
    }
  }

  return (
    <DialogOverlay
      id="Delete Members DialogOverlay"
      {...overlay}
      title={t('group.members.dialogOverlay.delete.heading', 'Delete Members')}
    >
      <Paragraph size="sm">{t(bodyText.key, bodyText.value)}</Paragraph>
      <DeleteMembersList members={members} />
      <DialogOverlayFooter>
        <DialogOverlayActions>
          <Button emphasis="high" onClick={confirmBtnOnClick}>
            {t('action.confirm', 'Confirm')}
          </Button>
          <Button emphasis="medium" onClick={overlay.close}>
            {t('action.cancel', 'Cancel')}
          </Button>
        </DialogOverlayActions>
      </DialogOverlayFooter>
    </DialogOverlay>
  )
}

function getBodyText(members) {
  const bodyText = {
    key: 'group.members.dialogOverlay.delete.body.singleMember',
    value: 'Are you sure you want to delete this member from the group?',
  }
  if (members.length > 1) {
    bodyText.key = 'group.members.dialogOverlay.delete.body.multipleMembers'
    bodyText.value = 'Are you sure you want to delete these members from the group?'
  }
  return bodyText
}
